webpackJsonp([129307454039216],{

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(3);
	
	var _marketing = __webpack_require__(8);
	
	var _blog = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overview = function (_React$Component) {
	  _inherits(Overview, _React$Component);
	
	  function Overview(props) {
	    _classCallCheck(this, Overview);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Overview.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'DocPage' },
	      _react2.default.createElement(_components.StripeBG, { bg2: "white", style: 'purple' }),
	      _react2.default.createElement(_marketing.Navbar, { className: 'grid-restrain' }),
	      _react2.default.createElement(
	        'section',
	        { className: 'grid-restrain grid-row full-8' },
	        _react2.default.createElement(_blog.DocToc, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'content markdown-doc grid-item' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'Patching Results'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'SnapTest allows results to be "patched", which means the ability to re-run only the failed tests in a suite to achieve an overall passing result. Patches are important when you\'re looking for a "green" test run result, but only a few tests fail and you don\'t want to run the entire suite again. They are initiated from the results list:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1555627666/docs/patches/patch1_.5x_2858.png', style: { "max-width": "none" } })
	            ),
	            _react2.default.createElement('p', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'info' },
	              'You may run a patch operation on a result as many times as you\'d like.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warn' },
	              'Patching is only possible if you\'ve structured your tests not to rely on each-other.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1555627685/docs/patches/patch2_1x_713.png', style: { "max-width": "none" } })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Overview;
	}(_react2.default.Component);
	
	exports.default = Overview;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-doc-patchingresults-js-94b33ce280d9c24719fb.js